import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Clienti from "./pages/Clienti";
import ClienteDetail from "./pages/ClienteDetail";
import Preventivi from "./pages/Preventivi";
import Lavori from "./pages/Lavori";
import LavoroDetail from "./pages/LavoroDetail";
import Calendario from "./pages/Calendario";
import Squadre from "./pages/Squadre";
import Incassi from "./pages/Incassi";
import Statistiche from "./pages/Statistiche";
import WhatsAppCenter from "./pages/WhatsAppCenter";
import Impostazioni from "./pages/Impostazioni";
import Accessi from "./pages/Accessi";
import Attivita from "./pages/Attivita";
import Fornitori from "./pages/Fornitori";
import IncassiDiversi from "./pages/IncassiDiversi";
import FornitoreDetail from "./pages/FornitoreDetail";
import OrePersonale from "./pages/OrePersonale";
import DaGestire from "./pages/DaGestire";
import "./index.css";

function Protected({ children, perm, office }) {
  const { user, loading, can, isOffice } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground animate-pulse">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if ((perm && !can(perm)) || (office && !isOffice)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/clienti" element={<Protected perm="view_clients"><Clienti /></Protected>} />
      <Route path="/clienti/:id" element={<Protected perm="view_clients"><ClienteDetail /></Protected>} />
      <Route path="/preventivi" element={<Protected perm="view_quotes"><Preventivi /></Protected>} />
      <Route path="/lavori" element={<Protected><Lavori /></Protected>} />
      <Route path="/lavori/:id" element={<Protected><LavoroDetail /></Protected>} />
      <Route path="/calendario" element={<Protected><Calendario /></Protected>} />
      <Route path="/attivita" element={<Protected office><Attivita /></Protected>} />
      <Route path="/incassi-diversi" element={<Protected perm="view_payments"><IncassiDiversi /></Protected>} />
      <Route path="/fornitori" element={<Protected office><Fornitori /></Protected>} />
      <Route path="/fornitori/:id" element={<Protected office><FornitoreDetail /></Protected>} />
      <Route path="/ore" element={<Protected office><OrePersonale /></Protected>} />
      <Route path="/da-gestire/:kind" element={<Protected office><DaGestire /></Protected>} />
      <Route path="/squadre" element={<Protected perm="manage_teams"><Squadre /></Protected>} />
      <Route path="/incassi" element={<Protected perm="view_payments"><Incassi /></Protected>} />
      <Route path="/statistiche" element={<Protected perm="view_stats"><Statistiche /></Protected>} />
      <Route path="/whatsapp" element={<Protected perm="manage_whatsapp"><WhatsAppCenter /></Protected>} />
      <Route path="/accessi" element={<Protected perm="manage_users"><Accessi /></Protected>} />
      <Route path="/impostazioni" element={<Protected perm="manage_settings"><Impostazioni /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
